import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".CarBackground-module_iconLarge__Uzeyo {\n  display: none;\n}\n@media (min-width: 768px) {\n  .CarBackground-module_iconLarge__Uzeyo {\n    display: inline-block;\n  }\n}\n\n.CarBackground-module_iconSmall__qZyt7 {\n  display: inline-block;\n}\n@media (min-width: 768px) {\n  .CarBackground-module_iconSmall__qZyt7 {\n    display: none;\n  }\n}";
var styles = {"iconLarge":"CarBackground-module_iconLarge__Uzeyo","iconSmall":"CarBackground-module_iconSmall__qZyt7"};
styleInject(css_248z);

export { styles as default };
